import {mapGetters, mapState} from "vuex";

export const baseSubtractiveMaxBidSelect = {
  data() {
    return {
      maxBids: [],
      maxBidIncrements: jsConfig.maxBidIncrements,
      bidLimit: jsConfig.bidLimit,
      bidStatuses: jsConfig.bidStatuses,
      toggleIncrements: false
    }
  },
  computed: {
    ...mapState(['allBidIncrements']),
    ...mapGetters(['getBid'])
  },
  methods: {
    getMinBid(isHighBidder) {
      if (isHighBidder) {
        return this.item.currentBid;
      }
      return Math.max(this.item.startingPrice, this.item.currentBid + 1);
    },
    updateMaxBidSelect() {
      const usersMaxBid = this.item.userBidStatus.maxBid;
      const isHighBidder = this.item.userBidStatus.status === this.bidStatuses.high;
      const minBid = this.getMinBid(isHighBidder);

      // remove all bids below min bid for user
      const minBidIndex = this.allBidIncrements.findIndex((increment) => increment.value >= minBid);
      let maxBidIncrements = minBidIndex >= 0 ? this.allBidIncrements.slice(minBidIndex) : [];

      // remove the user's current max bid if it exists and is greater than min
      if (usersMaxBid && usersMaxBid > minBid) {
        const maxBidIndex = maxBidIncrements.findIndex(({value}) => value === usersMaxBid);
        maxBidIncrements.splice(maxBidIndex, 1);
      }

      // restore current low-bid value
      if (this.selectedValue < minBid) {
        const currentLowBidOption = this.allBidIncrements.find(({value}) => value === this.selectedValue);
        maxBidIncrements.unshift(currentLowBidOption);
      }
      this.maxBids = maxBidIncrements;
    },
  },
  created() {
    const speedBid = this.getBid(this.item.id);
    if (speedBid) {
      this.updateMaxBidSelect();
    }
  },
}
